module.exports = __webpack_public_path__ + "static/media/1350_Cart_Medical_editHL.93e19f5c.png";